import React from 'react';
import {
    IonItem,
    IonLabel,
    IonInput,
    IonButton,
    IonCard,
    IonCardContent,
    IonText,
    IonIcon,
    IonRadio,
    IonRadioGroup
} from '@ionic/react';
import { checkmarkCircle, paperPlane, calendar, informationCircle } from 'ionicons/icons';

const SendInvoiceStep = ({
    settings,
    createdInvoiceIds,
    deliveryOption,
    scheduleDate,
    onSetDeliveryOption,
    onScheduleDateChange,
    onSendInvoices,
    onExit
}) => {
    const count = createdInvoiceIds.length;
    const messageTypes = settings?.automatedTasks?.messageTypes || [];
    const messageTypesDisplay = messageTypes.map(type => 
        type === 'sms' ? 'SMS' : type === 'email' ? 'Email' : type
    ).join(' and ');

    return (
        <div className="ion-padding" style={{ padding: '8px' }}>
            <div className="ion-text-center ion-margin-bottom">
                <IonIcon icon={checkmarkCircle} size="large" color="success" />
                <IonText color="primary">
                    <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold' }}>Invoices Created!</h2>
                </IonText>
                <IonText color="medium">
                    <p>
                        {count} invoice{count !== 1 ? 's' : ''} created successfully. Choose when to send below.
                    </p>
                </IonText>
            </div>

            <IonCard style={{ margin: '0 0 16px 0' }}>
                <IonCardContent>
                    <IonText color="primary">
                        <h3>
                            <IonIcon icon={informationCircle} /> Communication Method
                        </h3>
                    </IonText>
                    <IonText color="medium">
                        <p>
                            Invoices will be sent {messageTypesDisplay} based on your settings.
                        </p>
                    </IonText>
                </IonCardContent>
            </IonCard>

            <IonCard style={{ margin: '0 0 16px 0' }}>
                <IonCardContent>
                    <IonText color="primary">
                        <h3>
                            <IonIcon icon={calendar} /> When to Send
                        </h3>
                    </IonText>
                    <IonText color="medium">
                        <p>Choose when notifications should be sent</p>
                    </IonText>

                    <IonRadioGroup
                        value={deliveryOption}
                        onIonChange={(e) => onSetDeliveryOption(e.detail.value)}
                    >
                        <IonCard style={{ margin: '8px 0', padding: '8px' }}>
                            <IonItem>
                                <IonRadio value="now" slot="start" />
                                <IonLabel style={{ marginLeft: '12px' }}>
                                    <h3>
                                        <IonIcon icon={paperPlane} /> Send immediately
                                    </h3>
                                    <p>Send notifications right away</p>
                                </IonLabel>
                            </IonItem>
                        </IonCard>

                        <IonCard style={{ margin: '8px 0', padding: '8px' }}>
                            <IonItem>
                                <IonRadio value="schedule" slot="start" />
                                <IonLabel style={{ marginLeft: '12px' }}>
                                    <h3>
                                        <IonIcon icon={calendar} /> Schedule for later
                                    </h3>
                                    <p>Pick a future date to send</p>
                                </IonLabel>
                            </IonItem>
                        </IonCard>
                    </IonRadioGroup>
                    {deliveryOption === 'schedule' && (
                        <IonItem>
                            <IonInput
                                type="date"
                                value={scheduleDate ? new Date(scheduleDate).toISOString().split('T')[0] : ''}
                                onIonInput={(e) => onScheduleDateChange(e.detail.value)}
                                fill="solid"
                                placeholder="Select date"
                                helperText='This date will be applied to all generated invoices.'
                            />
                        </IonItem>
                    )}
                </IonCardContent>
            </IonCard>

            <IonCard color="light" style={{ margin: '0 0 16px 0' }}>
                <IonCardContent>
                    <IonText>
                        <p>
                            <IonIcon icon={informationCircle} /> Invoices will be sent {messageTypesDisplay}
                            {deliveryOption === 'schedule' ? ` on ${scheduleDate || 'selected date'}` : ' immediately'}.
                        </p>
                    </IonText>
                </IonCardContent>
            </IonCard>

            <div className="ion-margin-top">
                <IonButton
                    expand="block"
                    onClick={onSendInvoices}
                    disabled={deliveryOption === 'schedule' && !scheduleDate}
                >
                    <IonIcon icon={paperPlane} slot="start" />
                    Send Invoices
                </IonButton>
                <IonButton
                    expand="block"
                    fill="outline"
                    onClick={onExit}
                    className="ion-margin-top"
                >
                    Exit
                </IonButton>
            </div>
        </div>
    );
};

export default SendInvoiceStep;

